// State helpers of the reprocess dialog. A sheet mapping is { excel column: field },
// as saved in processor_mappings.config.

import { NO_SHEET_ERROR, sheetMappingErrors } from './sheetMapping.js';

export const sheetStatus = (preview) => {
  if (!preview.loaded) return 'unloaded';
  if (preview.missing_columns.length > 0 || preview.error || Object.keys(preview.mapping || {}).length === 0) return 'broken';
  return 'loaded';
};

// Loaded sheets start enabled with their saved mapping, minus the columns the file no longer has
export const initialDraft = (sheets) => Object.fromEntries(sheets.map((s) => [s.sheet, {
  enabled: s.loaded,
  mapping: Object.fromEntries(
    Object.entries(s.mapping || {}).filter(([column]) => !s.missing_columns.includes(column)),
  ),
}]));

// Same rules and messages as the upload screen
export const validateDraft = (draft, choices) => {
  const enabled = Object.entries(draft).filter(([, d]) => d.enabled);
  if (enabled.length === 0) return [NO_SHEET_ERROR];
  return enabled.flatMap(([sheet, d]) => sheetMappingErrors(sheet, d.mapping, choices));
};

const sameMapping = (a, b) => {
  const keys = Object.keys(a);
  return keys.length === Object.keys(b).length && keys.every((column) => a[column] === b[column]);
};

// True when the draft loads other sheets, or maps them otherwise, than the saved mapping.
// An unchanged draft is reprocessed with the saved mapping, so no duplicate mapping is saved.
export const draftChanged = (draft, sheets) => sheets.some((s) => {
  const d = draft[s.sheet];
  if (!d || d.enabled !== s.loaded) return true;
  return d.enabled && !sameMapping(d.mapping, s.mapping || {});
});

// Sheets loaded today that the draft no longer loads: the reprocess deletes their rows for good
export const droppedSheets = (draft, sheets) => sheets.filter((s) => s.loaded && !draft[s.sheet]?.enabled);

// The body of POST /history/{uuid}/reprocess: one entry per sheet to load, in file order
export const buildSheetsOverride = (draft, sheets) => sheets
  .filter((s) => draft[s.sheet]?.enabled)
  .map((s) => ({ sheet: s.sheet, mapping: draft[s.sheet].mapping }));
